export default {
      id: "pres_0-usage",
      viewBox: "0 0 55 61",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#pres_0",
      toString: function () {
        return this.url;
      }
    }